import { createDialog } from '../dialog'
import { fetchUnreadOfferNotificationsCount } from '../fetch'
import { globalState } from '../globalState'
import { trackOpenAction } from '../track'
import {
    OnLemonstandCategoryUpdateProperties,
    OnLemonstandNotificationsCreatedProperties,
    OnRewardProperties,
    PushHandlers,
    WebshopEvents,
} from '../types'
import { log, logError } from '../utils'
import { createIframeUrl } from '../utils/url'

export const onReward = (payload: OnRewardProperties): void => {
    log('OnReward: payload', payload)
    const { isCanvas } = globalState.getStore()
    if (isCanvas) {
        window.CanvasAgent?.instance?.hide()
        window.CanvasAgent?.instance?.refresh()
        window.CanvasAgent?.instance?.navigate()
        return
    }
    const url = createIframeUrl({
        route: encodeURIComponent(payload.successUrl),
        ...payload,
    })
    globalState.updateStore({
        lastPurchaseTab: payload.page,
        sourceId: 'successfulPayoutReward',
    })
    trackOpenAction(payload.sid)

    createDialog(url)
}

export const onLemonstandCategoryUpdate = ({ target, action, data }: OnLemonstandCategoryUpdateProperties): void => {
    globalState.shopMessageBus.post({
        eventName: WebshopEvents.LEMONSTAND_CATEGORY_UPDATE,
        target,
        data: { action, data },
    })
}

/**
 * this handler works in case of offer notification activation and deactivation
 */
export const onLemonstandNotificationsCreated = ({ notifCount }: OnLemonstandNotificationsCreatedProperties): void => {
    log('onLemonstandNotificationsCreated -> notifCount:', notifCount)
    const store = globalState.getStore()
    if (notifCount > 0) {
        // random delay in range 1-120 sec on LIVE, and 1-15 sec on TEST
        const randomDelayMs = Math.floor(Math.random() * (Number(store.networkId) < 250 ? 120_000 : 15_000))
        setTimeout(() => {
            fetchUnreadOfferNotificationsCount()
        }, randomDelayMs)
    } else {
        store.gameApi.invokeFn('setUnseenOffersCounter', 0).catch((error) => {
            logError('setUnseenOffersCounter error:', error)
        })
    }
}

export const createPushHandlers = (): PushHandlers => {
    return {
        reward: onReward,
        reward_received: onReward,
        [WebshopEvents.LEMONSTAND_CATEGORY_UPDATE]: onLemonstandCategoryUpdate,
        [WebshopEvents.LEMONSTAND_NOTIFICATIONS_CREATED]: onLemonstandNotificationsCreated,
    }
}
